import React from 'react';
import { Progress } from 'antd';
import { CreditUsageGraph } from 'components/CreditUsageGraph/CreditUsageGraph';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { formatIncome } from 'helpers/money.helper';
import Label from 'components/form/Label/Label';

const ProgressBar = props => {
  const progressBarClass = props.isOverCreditLimit
    ? 'progressBarContainerOverLimit'
    : 'progressBarContainer';

  if (props.isOverCreditLimit) {
    return (
      <div className={progressBarClass}>
        <Progress
          strokeWidth={5}
          showInfo={false}
          percent={100}
          success={{ percent: props.succesPercent }}
        />
      </div>
    );
  } else {
    return (
      <CreditUsageGraph
        creditUsagePercentage={props.limitPercentage}
        isCreditFactorBased
        hideInfo={true}
      />
    );
  }
};

const CreditUsageCollapseHeader = props => {
  const { name, balance, creditLimit } = props;
  const limitPercentage = Math.round((balance / creditLimit) * 100);
  const isOverCreditLimit = limitPercentage > 100;
  const succesPercent = isOverCreditLimit
    ? 100 - (limitPercentage - 100)
    : limitPercentage;

  return (
    <>
      <FlexContainer className={'flex-column format100'}>
        <FlexContainer className={'format100 justify-between'}>
          <Label className={'Subtitle-1 mSubtitle-2'}>{name}</Label>
          <Label
            className={'Subtitle-1 mSubtitle-2'}
          >{`${limitPercentage}%`}</Label>
        </FlexContainer>
        <FlexContainer className={'format100 justify-between margT4'}>
          <Label className={'Body-1 mBody-2 '}>
            {`Balance ${formatIncome(balance)}`}
          </Label>
          <Label className={'Body-1 mBody-2 '}>{`Limit ${formatIncome(
            creditLimit,
          )}`}</Label>
        </FlexContainer>
        <ProgressBar
          isOverCreditLimit={isOverCreditLimit}
          succesPercent={succesPercent}
          limitPercentage={limitPercentage}
        />
      </FlexContainer>
    </>
  );
};

export default CreditUsageCollapseHeader;
